import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import VesselTypeForm from '~/components/vesselTypeForm/vesselTypeForm';
import { vesselTypeValidationSchema } from '../../validation/vesselType';

export const createVesselTypeMutation = gql`
  mutation createVesselType($breweryId: Int!, $name: String!, $description: String, $volume: Float!, $quantity: Int!) {
    createVesselType(
      breweryId: $breweryId
      name: $name
      description: $description
      volume: $volume
      quantity: $quantity
    ) {
      id
      name
    }
  }
`;

export const VesselTypeCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createVesselTypeMutation}>
      {(vesselTypeCreate, { error }) => (
        <Formik
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={vesselTypeValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newCode = await vesselTypeCreate({
                variables: {
                  ...values,
                  breweryId: brewery.id
                },
                refetchQueries: ['vesselTypes']
              });
              history.push(`/settings/vesseltypes?new=${newCode.data.createVesselType.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={VesselTypeForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(VesselTypeCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/vesselTypeCreate/vesselTypeCreate.jsx